import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// créer un nouveau paiement
export const createPayment = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/studentPayment/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un plan de paiement spécifique
export const getPaymentById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPayment/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer tous les paiements d'une année
export const getAllPaymentByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPayment/all/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getFinancialStudentSummary = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPayment/summary/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les paiements d'un étudiant
export const getStudentPaymentByYear = async (
  id_studentProfil,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/studentPayment/payment/${id_academicYear}/${id_studentProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentDiscountByYear = async (
  id_studentProfil,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/studentPayment/discount/${id_academicYear}/${id_studentProfil}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un paiement
export const updatePayment = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/studentPayment/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un paiement
export const deletePayment = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/studentPayment/${id}`,
  );
  return response.data;
};

// --------------------------PDF-------------------------------------------------------

export const generatePaymentRecu = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-recu-paiement`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const generateFinancialReport = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-rapport-financier`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};
